module.exports = __webpack_public_path__ + "img/toll.2d463b13.svg";